import React from 'react'
import Container from 'react-bootstrap/Container'

import './index.scss'

type JumbotronProps = {
    children?: React.ReactNode
}

const Jumbotron: React.FC<JumbotronProps> = ({ children }) => {
    return (
        <Container
            fluid
            className='custom-jumbotron mt-4 px-5 pt-2 pb-2 rounded mx-auto shadow text-center'
        >
            {children}
        </Container>
    )
}

export default Jumbotron